<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="Биллинг уведомлений"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Биллинг уведомлений'},
    data: () => ({
      subnav: [
        {
          text: 'Создать',
          to: '/billing/notifications/create',
          exact: true,
          permission: 'web_billing_notifications',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/notifications/index.vue